/* import __COLOCATED_TEMPLATE__ from './radio-group.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import { Keys } from 'ember-headlessui/utils/keyboard';
import { modifier } from 'ember-modifier';
let RadioGroupComponent = (_class = class RadioGroupComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "guid", guidFor(this));
    _defineProperty(this, "radioGroupGuid", `headlessui-radiogroup-${this.guid}`);
    _defineProperty(this, "radioGroupLabel", `headlessui-label-${this.guid}`);
    _initializerDefineProperty(this, "activeOption", _descriptor, this);
    //-option component
    _initializerDefineProperty(this, "activeValue", _descriptor2, this);
    //string
    _initializerDefineProperty(this, "selectedValue", _descriptor3, this);
    //string
    _initializerDefineProperty(this, "options", _descriptor4, this);
    _defineProperty(this, "tabIndex", modifier(() => {
      this.setTabIndex();
      return () => {
        this.setTabIndex();
      };
    }));
  }
  get activeOptionIndex() {
    return this.options.indexOf(this.activeOption);
  }
  goToFirstOption() {
    let firstOption = this.options.find(option => option);
    this._setActiveOption(firstOption);
  }
  goToLastOption() {
    let lastOption = this.options.slice().reverse().find(option => option);
    this._setActiveOption(lastOption);
  }
  goToNextOption() {
    let nextOption = this.options.find((option, index) => {
      if (index <= this.activeOptionIndex) {
        return false;
      }
      return option;
    });
    this._setActiveOption(nextOption);
  }
  goToPreviousOption() {
    let previousOption = this.options.slice().reverse().find((option, index) => {
      if (this.activeOptionIndex !== -1 && this.options.length - index - 1 >= this.activeOptionIndex) {
        return false;
      }
      return option;
    });
    this._setActiveOption(previousOption);
  }
  handleClick(value) {
    this.activeValue = value;
    this.selectedValue = value;
  }
  handleKeyup(event) {
    switch (event.key) {
      case Keys.Space:
      case Keys.Enter:
        event.preventDefault();
        return this.onKeySelect(event);
      case Keys.ArrowDown:
      case Keys.ArrowRight:
        event.preventDefault();
        if (document.activeElement === this.options[this.options.length - 1].element) return this.goToFirstOption();
        return this.goToNextOption();
      case Keys.ArrowUp:
      case Keys.ArrowLeft:
        event.preventDefault();
        if (document.activeElement === this.options[0].element) return this.goToLastOption();
        return this.goToPreviousOption();
      default:
        break;
    }
  }
  onChange(option) {
    if (this.args.onChange) {
      this.args.onChange(option);
    }
  }
  onKeySelect(event) {
    if (this.args.disabled) return;
    let hasOptionNotBeenSelected = this.selectedValue !== event.target.ariaLabel;
    if (this.args.onChange && hasOptionNotBeenSelected) {
      this.selectedValue = event.target.ariaLabel;
      this.onChange(this.selectedValue);
    }
  }
  async registerOption(option) {
    let {
      options
    } = this;
    options.push(option);
    await Promise.resolve(() => this.options = options);
  }
  async unregisterOption(option) {
    let {
      options
    } = this;
    let index = options.indexOf(option);
    options.splice(index, 1);
    await Promise.resolve(() => this.options = options);
  }
  setTabIndex() {
    this.options.forEach(option => {
      let isFirstOption = this.options[0]?.id === option.id;
      let containsCheckedOption = this.options.filter(option => {
        return option.id && option.value === this.activeValue && option.value !== null;
      });
      let checked = this.activeValue === option.value;
      if (this.disabled) {
        option.element.tabIndex = -1;
        return;
      }
      if (checked) {
        this.activeOption = option;
        option.element.tabIndex = 0;
        return;
      }
      if (!containsCheckedOption.length && isFirstOption) {
        this.activeOption = option;
        option.element.tabIndex = 0;
        return;
      }
      option.element.tabIndex = -1;
    });
  }
  _setActiveOption(option) {
    if (option) {
      option.element.focus();
      this.activeOption = option;
      this.activeValue = option.value;
      this.setTabIndex();
      this.onChange(option.value);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "activeOption", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "activeValue", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.value;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectedValue", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "options", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "goToFirstOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToFirstOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToLastOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToLastOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToNextOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToNextOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToPreviousOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToPreviousOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeyup", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onKeySelect", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onKeySelect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unregisterOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unregisterOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setTabIndex", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setTabIndex"), _class.prototype), _class);
export { RadioGroupComponent as default };